export default __webpack_public_path__ + "static/media/Fouraai-logo.2cce278f.png";